import { render } from "./SavingsSummary.vue?vue&type=template&id=6fa10b70&scoped=true"
import script from "./SavingsSummary.vue?vue&type=script&lang=js"
export * from "./SavingsSummary.vue?vue&type=script&lang=js"

import "./SavingsSummary.vue?vue&type=style&index=0&id=6fa10b70&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6fa10b70"

export default script